/** A margin, or an explicit "we cannot say". Zero revenue has no margin, and
 *  rendering it as 0% claims break-even, which is a different thing. */
export function MarginCell({ value }: { value: number | null }) {
  if (value === null || value === undefined) {
    return (
      <span className="text-muted-foreground" title="No revenue in this period">
        —
      </span>
    );
  }
  const tone = value < 0 ? "text-destructive" : "text-foreground";
  return <span className={`tabular-nums ${tone}`}>{value.toFixed(1)}%</span>;
}
